/**
 * Legal Pages Types
 *
 * Types for managing legal pages content (Privacy, Terms, About, Contact).
 * Content is stored as Markdown and editable by administrators.
 */
/**
 * Contact subject labels (for display)
 */
export const CONTACT_SUBJECTS = {
    general: { fr: 'Question générale', en: 'General question' },
    technical: { fr: 'Support technique', en: 'Technical support' },
    billing: { fr: 'Facturation / Abonnement', en: 'Billing / Subscription' },
    suggestion: { fr: 'Suggestion d\'amélioration', en: 'Feature suggestion' },
    bug: { fr: 'Signaler un bug', en: 'Report a bug' },
    other: { fr: 'Autre', en: 'Other' },
};
/**
 * Legal page metadata for display
 */
export const LEGAL_PAGES_META = {
    privacy: { titleFr: 'Politique de confidentialité', titleEn: 'Privacy Policy', icon: '🔒' },
    terms: { titleFr: 'Conditions d\'utilisation', titleEn: 'Terms of Service', icon: '📋' },
    about: { titleFr: 'À propos', titleEn: 'About', icon: 'ℹ️' },
    contact: { titleFr: 'Contact', titleEn: 'Contact', icon: '✉️' },
};
//# sourceMappingURL=legal-pages.js.map